import React from "react";
import PropTypes from "prop-types";
import Question from "./Question";
import DemographicsForm from "./DemographicsForm";
import QuizPopup from "./QuizPopup";
import questions from './questions';
import getToken from './getToken';
import _ from 'lodash';


class Quiz extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      incomplete: _.clone(questions),
      complete: [],
      quizComplete: false,
      surveyId: null,
      finishedSurvey: null, // set if Survey completed after Aspirations
      quiz: true, // show Quiz initially
    };
    this.quizRef = React.createRef();
    this.popupRef = React.createRef();
    this.demographicsRef = React.createRef();
    this.nextQuestion = this.nextQuestion.bind(this);
    this.saveResponse = this.saveResponse.bind(this);
    this.submitSurvey = this.submitSurvey.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleFinishQuiz = this.handleFinishQuiz.bind(this);
    this.toggleFade = this.toggleFade.bind(this);
  }


  componentDidMount() {
    setTimeout(() => this.toggleFade(this.quizRef), 200);
  }


  nextQuestion(res){
    const newState = this.state;
    newState.incomplete.shift(); // remove completed question from list
    this.setState(newState);
  }


  // Store completed response from <Question />
  saveResponse(res){
    const newState = this.state;
    newState.complete.push(res);
    this.setState(newState);
  }


  constructSurvey(){
    const survey = {};

    this.state.complete.forEach(answer => {
      survey[`fact_${answer.number}_answer`] = answer.answer
      survey[`fact_${answer.number}_reaction`] = answer.reaction
      survey[`fact_${answer.number}_score`] = answer.score
      survey[`fact_${answer.number}_comment`] = answer.comment
    })

    // Add Demographic Fields if no existing survey
    if(!this.props.survey){
      const demoFields = ['year_of_birth', 'area_type', 'local_authority'];
      demoFields.forEach(f => { if(this.state[f]) survey[f] = this.state[f] })
    }

    return survey;
  }


  submitSurvey(e){
    if(e) e.preventDefault();

    const survey = this.constructSurvey();

    let url = '/surveys';

    // Add ID to survey and URL if exists,
    if(this.props.survey) {
      url = url.concat(`/${this.props.survey.id}`);
      survey.id = this.props.survey.id;
    }

    // Request CREATE
    fetch(url, {
      method: `${this.props.survey ? 'PATCH' : 'POST'}`,
      headers: {
        'X-CSRF-Token': getToken(),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ survey: survey })
    })
      .then(res => res.json())
      .then(res => {
        // Render Errors - ISSUE - won't pick up the updated question list
        if(!res.success) this.setState({ errors: res.error });
        // Render Next Button and insert Survey ID into state
        else {
          this.setState(
            {
              surveyId: res.data.id,
              finishedSurvey: survey
            },
            this.fadePopup
          );
        }
      })
  }


  handleFinishQuiz(){
    if(this.props.survey){
      this.submitSurvey(); // will automatically fade popup when submitted
    } else {
      this.toggleFade(this.quizRef);
      setTimeout(
        () => {
          window.scrollTo(0,0);
          this.setState({ quiz:false }, this.renderDemographics)
        },
        700
      )
    }
  }


  // ABSTRACT TO ANONYMOUS FUNCTION
  toggleFade(ref, callback = undefined){
    ref.current.classList.toggle('transparent');
    if(callback) callback();
  }



  renderDemographics(){
    document.getElementById(`select-year-of-birth`).focus()
    this.toggleFade(this.demographicsRef);
  }


  fadePopup(){
    this.popupRef.current.classList.add('show');
    this.popupRef.current.classList.toggle('accept-click');
  }


  // TODO - DUPLICATED FROM FUTURE, can i refactor this ???
  handleSelectChange(e){
    const newState = this.state;
    newState[e.target.name] = e.target.value;
    this.setState(newState);
    this.focusNextSelect(e.target)
  }


  focusNextSelect(el){
    if(el.nextSibling){
      const focusable = el.nextSibling.nextSibling;
      if(focusable && focusable.nodeName === 'SELECT'){
        focusable.focus();
      }
    }
  }


  render () {

    if(this.state.quiz){

      return (

        <React.Fragment>

          {/* QUIZ */}
          <div
            ref={this.quizRef}
            id='quiz'
            className='transparent'
          >

            {/*  Render Errors  */}
            {this.state.error &&
              this.state.error.map((e, i) => (
                <h4 key={`error${i}`}>{e}</h4>
              ))
            }

            {/*  QUESTIONS */}
            <Question
              question={this.state.incomplete[0]}
              nextQuestion={this.nextQuestion}
              saveResponse={this.saveResponse}
              finishQuiz={this.handleFinishQuiz}
              isLast={this.state.incomplete.length === 1}
            />

          </div> {/* END OF QUIZ */}

          <QuizPopup
            ref={this.popupRef}
            survey={this.props.survey}
            id={this.state.surveyId}
            finishedSurvey={this.state.finishedSurvey}
          />

        </React.Fragment>
      );
    } else {

      return (

        <React.Fragment>

          <DemographicsForm
            ref={this.demographicsRef}
            handleSelectChange={this.handleSelectChange}
            submitSurvey={this.submitSurvey}
          />

          <QuizPopup
            ref={this.popupRef}
            survey={this.props.survey}
            id={this.state.surveyId}
            finishedSurvey={this.state.finishedSurvey}
          />

        </React.Fragment>

      )
    }
  }
}

export default Quiz;
